import { useSuspenseQuery } from '@apollo/client';

import { CompaniesRecentlyClaimedOrder } from '@xing-com/crate-common-graphql-types';

import { RecentlyClaimedCompaniesDocument } from '../../graphql/queries/recently-claimed-companies.gql-types';

const ORDERS = {
  RANDOM: CompaniesRecentlyClaimedOrder.Random,
  ID_DESC: CompaniesRecentlyClaimedOrder.IdDesc,
};

type RecentlyClaimedCompaniesProps = {
  limit: number;
  offset?: number;
};

const useRecentlyClaimedCompanies = ({
  limit = 4,
  offset = 0,
}: RecentlyClaimedCompaniesProps) => {
  const variables = {
    limit,
    offset,
    order: ORDERS.RANDOM,
  };
  const { error, ...rest } = useSuspenseQuery(
    RecentlyClaimedCompaniesDocument,
    {
      variables,
      errorPolicy: 'all',
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    error,
    ...rest,
  };
};

export { useRecentlyClaimedCompanies, ORDERS };
